import {FC} from 'react'
import clsx from 'clsx'
import {NotificationItem} from 'models/Notification'
import {KTSVG} from 'helpers'
import {formatDate, getTimeAgo} from 'utils/helper'
import {useTranslation} from 'react-i18next'

interface Props {
 notification: NotificationItem
 onTakeAction?: (item: NotificationItem) => void
}

const NotificationCard: FC<Props> = ({
 notification,
 onTakeAction,
}) => {
 const {t} = useTranslation()

 const getNotificationTime = (dateStr: string) => {
  const now = new Date()
  const date = new Date(dateStr)

  const today = new Date(
   now.getFullYear(),
   now.getMonth(),
   now.getDate()
  )

  const itemDate = new Date(
   date.getFullYear(),
   date.getMonth(),
   date.getDate()
  )

  if (itemDate.getTime() === today.getTime()) {
   return getTimeAgo(dateStr)
  }

  return formatDate(dateStr)
 }
 return (
  <div
   className={clsx(
    'rounded-xl border px-5 py-4 mb-4 flex justify-between gap-5 transition-all',
    notification.is_read
     ? 'bg-white border-[#E6EBF0]'
     : 'bg-[#F5F9FF] border-[#DCE8F8]'
   )}
  >
   <div className='flex gap-4 flex-1'>
    <div className='relative'>
     {!notification.is_read && (
      <div className='w-[8px] h-[8px] bg-red-500 rounded-full absolute left-0 top-0' />
     )}

     <div
      className={`w-[40px] h-[40px] rounded-full flex items-center justify-center ${
       notification.is_read
        ? 'bg-[#F5F8FA]'
        : 'bg-[#EAF3FF]'
      }`}
     >
      <KTSVG
       path={
        notification.is_read
         ? '/media/icons/read_notification.svg'
         : '/media/icons/unread_notification.svg'
       }
       className='svg-icon-2'
      />
     </div>
    </div>

    <div className='flex-1'>
     <div className='text-[16px] font-semibold text-[#181C32]'>
      {notification.title}
     </div>

     <div className='text-[14px] text-[#5E6278] mt-1'>
      {notification.body}
     </div>

     {notification.deep_link && (
      <button
       className='mt-3 border border-[#DCE1E7] rounded-lg px-4 py-2 text-primary text-[13px] font-medium'
       onClick={() => onTakeAction?.(notification)}
      >
       {t('notification.viewDetails')}
      </button>
     )}
    </div>
   </div>

   <div className='text-[12px] text-[#A1A5B7] whitespace-nowrap'>
    {getNotificationTime(notification.created_at)}
   </div>
  </div>
 )
}

export default NotificationCard
